module.exports = __webpack_public_path__ + "img/SFTP.71ec8b31.png";